import { Box, IconButton, Typography } from '@mui/material';
import { ArrowBack } from '@mui/icons-material';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import { AppContext } from 'src/sporttia/AppContext';
import { useContext } from 'react';

type Props = {
    title: string;
    subtitle?: string | React.ReactNode;
    onBack?: () => void;
    help?: () => void;
    /** Sin margen inferior: se está pintando dentro de la cabecera compartida. */
    compact?: boolean;
};

export default function PageTitle({
    title,
    subtitle,
    onBack,
    help,
    compact = false,
}: Props): React.ReactElement {
    const cxt = useContext(AppContext)!;

    return (
        <Box
            sx={{
                mb: compact ? 0 : 3,
                display: 'flex',
                alignItems: 'center',
                gap: 2,
            }}
        >
            {onBack && onBack.constructor === Function && (
                <IconButton
                    onClick={onBack}
                    size="small"
                    className="border-border border"
                >
                    <ArrowBack fontSize="small" />
                </IconButton>
            )}
            <Box sx={{ flex: 1 }}>
                <Typography
                    variant="h4"
                    component="h1"
                    sx={{
                        // 18px/700 con leading-tight, como el título de la
                        // cabecera de competitions
                        fontWeight: 700,
                        color: 'text.primary',
                        lineHeight: 1.25,
                        fontSize: '1.125rem',
                    }}
                >
                    {title}
                </Typography>
                {subtitle && (
                    <Typography
                        variant="body2"
                        sx={{
                            color: 'var(--muted-foreground)',
                            lineHeight: 1.25,
                        }}
                    >
                        {subtitle}
                    </Typography>
                )}
            </Box>
            {help && cxt?.sc?.zero && (
                <IconButton
                    id="page-help"
                    onClick={help}
                    aria-label={cxt?.t?.('common.help')}
                    size="small"
                >
                    <HelpOutlineIcon />
                </IconButton>
            )}
        </Box>
    );
}
